// reducers/products.reducer.ts
import { Action, createReducer, on } from '@ngrx/store';
import {
  CurrentProfileActions as CurrentProfileActions,
  
} from './profile.actions';


import { UserProfile } from 'src/app/shared/models/base.models';
import { SystemProcessLoadingStatus } from 'src/app/shared/models/system.models';


// export interface ProductsOfferState extends EntityState<OfferItem> {}
export interface ProfileState {
  currentUserProfile: UserProfile;
  currentUserProfileProcess: { status: SystemProcessLoadingStatus; error: any };
  
  loaded: boolean;
  error: any;
}


// export const productOfferAdapter = createEntityAdapter<OfferItem>();

const initialState: ProfileState = {
  currentUserProfile: undefined,
  currentUserProfileProcess: { status: 'none', error: null },

  loaded: false,
  error: null,
};

export const profileReducer = createReducer(
  initialState,

  // ? Products List Related
  

  on(CurrentProfileActions.load, (state) => {
    return {
      ...state,
      currentUserProfileProcess: { status: 'loading', error: null },
    };
  }),
  on(CurrentProfileActions.loadSuccess, (state, { profile }) => {
    return {
      ...state,
      currentUserProfile: profile,
      currentUserProfileProcess: { status: 'done', error: null },
      }
    }),
  on(CurrentProfileActions.loadFailure, (state, { error }) => ({
    ...state,
    error,
    currentUserProfileProcess: { status: 'error', error: error.message },
  })),




  // on(deleteProduct, (state, { product }) =>
  //   productAdapter.removeOne(product.id, { ...state, loading: false })
  // ),
  // on(forgetSession, clearCurrentProduct, (state) => initialState)
);
